import Vue from 'vue';
import {
    Alert,
    Aside,
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    Button,
    Card,
    Checkbox,
    CheckboxGroup,
    Col,
    Collapse,
    CollapseItem,
    Container,
    DatePicker,
    Descriptions,
    DescriptionsItem,
    Dialog,
    Divider,
    Drawer,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Empty,
    Footer,
    Form,
    FormItem,
    Header,
    Image,
    Input,
    InputNumber,
    Link,
    Loading,
    Main,
    Menu,
    MenuItem,
    MenuItemGroup,
    MessageBox,
    Notification,
    Option,
    PageHeader,
    Pagination,
    Popconfirm,
    Popover,
    Progress,
    Radio,
    Result,
    Row,
    Select,
    Step,
    Steps,
    Submenu,
    Switch,
    Table,
    TableColumn,
    TabPane,
    Tabs,
    Tag,
    TimeSelect,
    Tooltip,
    Upload
} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import '@/assets/css/element-variables.scss'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

locale.use(lang)

Vue.use(Result);
Vue.use(Upload);
Vue.use(Radio);
Vue.use(TimeSelect);
Vue.use(Progress);
Vue.use(CheckboxGroup);
Vue.use(Link);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(PageHeader);
Vue.use(Checkbox);
Vue.use(InputNumber);
Vue.use(Switch);
Vue.use(Button);
Vue.use(Badge);
Vue.use(Row);
Vue.use(Col);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Container);
Vue.use(Aside);
Vue.use(Header);
Vue.use(Image);
Vue.use(Tag);
Vue.use(Main);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Dialog);
Vue.use(Submenu);
Vue.use(MenuItemGroup);
Vue.use(Popconfirm);
Vue.use(Popover);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Tooltip);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Footer);
Vue.use(Card);
Vue.use(DatePicker);
Vue.use(Loading);
Vue.use(Drawer);
Vue.use(Divider);
Vue.use(Pagination);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Alert);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Empty);

Vue.component(CollapseTransition.name, CollapseTransition)
Vue.use(Loading.directive);
Vue.prototype.$notify = Notification;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
